import React from 'react';

const NotificationCenter = () => {
  return <>Notification center</>;
};

export default NotificationCenter;
